import { Controller } from "@hotwired/stimulus"

// Updates the session-template occurrence preview before the template is saved.
export default class extends Controller {
  static targets = ["startDate", "startTime", "endDate", "day", "list", "empty"]
  static values = {
    horizonDays: Number,
    locale: String,
    maxOccurrences: Number
  }

  connect() {
    this.update()
  }

  update() {
    const occurrences = this.previewOccurrences()

    this.render(occurrences)
  }

  previewOccurrences() {
    const startsOn = this.parseDate(this.startDateTarget.value)
    const startTime = this.parseTime(this.startTimeTarget.value)
    const selectedDays = this.selectedDays()

    if (!startsOn || !startTime || selectedDays.length === 0) return []

    const endsOn = this.parseDate(this.endDateTarget.value) || this.addDays(startsOn, this.horizonDaysValue)
    const occurrences = []

    for (let date = new Date(startsOn); date <= endsOn && occurrences.length < this.maxOccurrencesValue; date = this.addDays(date, 1)) {
      if (!selectedDays.includes(date.getDay())) continue

      occurrences.push(new Date(date.getFullYear(), date.getMonth(), date.getDate(), startTime.hours, startTime.minutes))
    }

    return occurrences
  }

  render(occurrences) {
    this.listTarget.innerHTML = occurrences.map((occurrence) => `<li class="text-sm text-slate-700">${this.formatOccurrence(occurrence)}</li>`).join("")
    this.listTarget.classList.toggle("hidden", occurrences.length === 0)
    this.emptyTarget.classList.toggle("hidden", occurrences.length > 0)
  }

  selectedDays() {
    return this.dayTargets.filter((checkbox) => checkbox.checked).map((checkbox) => Number.parseInt(checkbox.value, 10))
  }

  parseDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "")
    if (!match) return null

    return new Date(Number.parseInt(match[1], 10), Number.parseInt(match[2], 10) - 1, Number.parseInt(match[3], 10))
  }

  parseTime(value) {
    const match = /^(\d{1,2}):(\d{2})$/.exec(value || "")
    if (!match) return null

    return { hours: Number.parseInt(match[1], 10), minutes: Number.parseInt(match[2], 10) }
  }

  addDays(date, days) {
    const nextDate = new Date(date)
    nextDate.setDate(nextDate.getDate() + days)
    return nextDate
  }

  formatOccurrence(occurrence) {
    const locale = this.localeValue || "en"
    const date = new Intl.DateTimeFormat(locale, { weekday: "long", month: "long", day: "numeric", year: "numeric" }).format(occurrence)
    const time = new Intl.DateTimeFormat(locale, { hour: "numeric", minute: "2-digit", hour12: !locale.startsWith("ro") }).format(occurrence)

    return locale.startsWith("ro") ? `${date}, ora ${time}` : `${date} at ${time}`
  }
}
